import React from "react";
import { MenuItem, TextField } from "@mui/material";

import { Say } from "../../../../../../arc/locale/consts.js";
import { Locale } from "../../../../../assets/Locale.js";
import { getProfileErrorId } from "../../profileValidation";

import "./PersonalFormField.scss";

const getFieldProps = field=>{
    const htmlInput = {};
    if (field.maxLength) { htmlInput.maxLength = field.maxLength; }
    if (field.max) { htmlInput.max = field.max; }

    if (field.type !== "date") {
        return {
            slotProps:{ htmlInput }
        };
    }

    return {
        slotProps:{
            htmlInput,
            inputLabel:{ shrink:true }
        }
    };
};

const renderOptions = (say, field)=>{
    if (!field.options) { return null; }
    return field.options.map(option=>(
        <MenuItem key={option.value} value={option.value}>
            {say(Say.id("locale", option.value))}
        </MenuItem>
    ));
};

export const PersonalFormField = (props)=>{
    const { field, fieldError, showError, value, onBlur, onChange } = props;
    const say = Locale.use();
    const className = field.wide ? "BlimpMuiForm-field isWide" : "BlimpMuiForm-field";

    return (
        <TextField
            {...getFieldProps(field)}
            autoComplete={field.autoComplete}
            className={className}
            error={showError}
            fullWidth
            helperText={showError ? say(getProfileErrorId(field.name, fieldError)) : " "}
            label={say(Say.id("profile", "field", field.name))}
            name={field.name}
            onBlur={onBlur}
            onChange={onChange}
            required={field.required}
            select={field.select}
            type={field.type || "text"}
            value={value ?? ""}
            variant="outlined"
        >
            {renderOptions(say, field)}
        </TextField>
    );
};
